module.exports = __webpack_public_path__ + "static/media/login-bg.54952816.png";